interface Props {
  className?: string;
  color: string;
}

export default function GlobeIcon({className, color}: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.6 7H18.4M1.6 13H18.4M1 10C1 11.1819 1.23279 12.3522 1.68508 13.4442C2.13738 14.5361 2.80031 15.5282 3.63604 16.364C4.47177 17.1997 5.46392 17.8626 6.55585 18.3149C7.64778 18.7672 8.8181 19 10 19C11.1819 19 12.3522 18.7672 13.4442 18.3149C14.5361 17.8626 15.5282 17.1997 16.364 16.364C17.1997 15.5282 17.8626 14.5361 18.3149 13.4442C18.7672 12.3522 19 11.1819 19 10C19 7.61305 18.0518 5.32387 16.364 3.63604C14.6761 1.94821 12.3869 1 10 1C7.61305 1 5.32387 1.94821 3.63604 3.63604C1.94821 5.32387 1 7.61305 1 10Z"
        stroke={color}
        strokeWidth={1.5}
      />
      <path
        d="M9.50016 1C7.8155 3.69961 6.92236 6.81787 6.92236 10C6.92236 13.1821 7.8155 16.3004 9.50016 19M10.5002 1C12.1848 3.69961 13.078 6.81787 13.078 10C13.078 13.1821 12.1848 16.3004 10.5002 19"
        stroke={color}
        strokeWidth={1.5}
      />
    </svg>
  );
}
